import gql from "graphql-tag";

export const ACCEPT_INVITE = gql`
  mutation($input: acceptClientInviteInput) {
    acceptClientInvite(input: $input)
  }
`;
